import * as React from "react";
import LoginScreen from "./loginScreen";
import BolDescription from "./bolDescription";
import MarketSelection from "./MarketSelection/marketselection";
import Acknowledgement from "./Acknowledgement/acknowledgement";
import GermanOptions from "./germanOptions";
import FileUploadInformation from "./FileUpload/fileUploadInformation";
import FileUploadVerification from "./FileUpload/fileUploadVerification";
import FileUploadConfirmation from "./FileUpload/fileUploadConfirmation";
import ErrorPage from "./ErrorPage/errorPage";
import { UserLoginData } from "../TypeScript/interfaces";
import LogoutScreen from "./logoutScreen";

interface Props {
  selectedPage: string;
  country: string;
  selectedOption: string;
  userLoginData: UserLoginData;
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  setDisplayBOList: React.Dispatch<React.SetStateAction<boolean>>;  
  setUserLoginData: React.Dispatch<React.SetStateAction<UserLoginData>>;
  warnings:string[];
  setWarnings: React.Dispatch<React.SetStateAction<string[]>>;
}

const Mainsetup: React.FC<Props> = (props) => {
  const {    
    setSelectedPage,
    setSelectedCountry,
    setSelectedOption,
    setDisplayBOList,
    setUserLoginData,
    setWarnings,
    selectedPage,
    country,
    selectedOption,
    userLoginData,
    warnings
  } = props;

  const displayPage = (selectedPage: string) => {
    switch (selectedPage) {
      case "BolDescription":
        return <BolDescription />;
      case "LoginScreen":
        return <LoginScreen setSelectedPage={setSelectedPage} setDisplayBOList={setDisplayBOList} setUserLoginData={setUserLoginData} />;
      case "Logout":
        return <LogoutScreen />;
      case "MarketSelection":
        return (
          <MarketSelection
            setSelectedPage={setSelectedPage}
            setSelectedCountry={setSelectedCountry}
          />
        );
      case "Acknowledgement":
        return (
          <Acknowledgement
            setSelectedPage={setSelectedPage}
            selectedPage={selectedPage}
            setSelectedCountry={setSelectedCountry}
            country={country}
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
          />
        );
        case "GermanOptions":
          return (
            <GermanOptions
              setSelectedPage={setSelectedPage}
              selectedPage={selectedPage}
              setSelectedCountry={setSelectedCountry}
              country={country}
              setSelectedOption={setSelectedOption}
              selectedOption={selectedOption}
            />
          );        
      case "FileUploadInfo":
        return (
          <FileUploadInformation
            setSelectedPage={setSelectedPage}
            selectedPage={selectedPage}
            setSelectedCountry={setSelectedCountry}
            country={country}
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}    
            userLoginData={userLoginData}     
            warnings={warnings}   
            setWarnings={setWarnings}
          />
        );
      case "FileUploadVerification":
        return (
          <FileUploadVerification
            setSelectedPage={setSelectedPage}
            selectedPage={selectedPage}
            setSelectedCountry={setSelectedCountry}
            country={country}
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
            warnings={warnings}
          />
        );
      case "ErrorPage":
        return (
            <ErrorPage />
        )
      case "FileUploadConfirmation":
        return (
          <FileUploadConfirmation
            setSelectedPage={setSelectedPage}
            selectedPage={selectedPage}
            setSelectedCountry={setSelectedCountry}
            country={country}
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
          />
        );
    }
  };

  return (
    <div id="mainsetup" className="grid-6">      
      {displayPage(selectedPage)}
    </div>
  );
};

export default Mainsetup;
